import _XIcon from "@adsk/alloy-react-icon/es/lib/XIcon";
var _IconButton$propTypes;
const _excluded = ["style", "children", "disabled", "showEscapeLabel", "type", "renderIcon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@adsk/alloy-react-button';
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

/**
 * Close Button.
 */
const CloseButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      children,
      disabled = false,
      showEscapeLabel = true,
      type = 'button',
      renderIcon = _XIcon.renderIcon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("./i18n/".concat(locale, ".json"));
  });
  const target = useForwardedRef(ref);
  return /*#__PURE__*/React.createElement(Tooltip, {
    "data-testid": "close-button-tooltip",
    content: showEscapeLabel ? T.translate('CLOSE_ESC') : T.translate('CLOSE'),
    target: target,
    getTargetProps: () => _objectSpread({
      ['data-testid']: 'close-button',
      disabled,
      type,
      renderIcon
    }, props),
    renderTarget: props => /*#__PURE__*/React.createElement(Tooltip.Target, _extends({}, props, {
      shouldWrapChildren: false
    }))
  }, /*#__PURE__*/React.createElement(IconButton, {
    style: [{
      height: 24
    }, style]
  }));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = {
  /** BasicButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** button html type, eg: submit */
  type: (_IconButton$propTypes = IconButton.propTypes) === null || _IconButton$propTypes === void 0 ? void 0 : _IconButton$propTypes.type,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onclick event for button */
  onClick: PropTypes.func,
  /** Modify tooltip if Esc will be used to close */
  showEscapeLabel: PropTypes.bool
};
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map